<p-dialog [visible]="true" [breakpoints]="{'430px': '100%'}" [style]="{width: '80%'}" [baseZIndex]="10000"
  [modal]="true" [maximizable]="false" [draggable]="false" [resizable]="false">
  <dialog-header [title]="app.translations.GBL_btn_AdvancedFiltersText" [settings]="settings"
    [icon]="faSquareCheck"></dialog-header>
  <div class="row" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
    <div class="col-12 animated fadeIn padding15" style="z-index: 50 !important;">
      <query-builder [(ngModel)]="query" [config]="config" [allowRuleset]='true'>
        <ng-container *queryInput="let rule; type: 'date'">
          <div class="custom-date-container">
            <date-picker [userDateFormat]="settings.dateFormatSetting" style="z-index: 100000; position: fixed;"
              (dateSelected)="dateInputUpdated($event, rule)" [rule]="rule"></date-picker>
          </div>
        </ng-container>
        <ng-container *queryInput="let rule; type: 'boolean'">          
          <mat-checkbox [(ngModel)]="rule.value" style="transform: translateY(5px);"></mat-checkbox>               
        </ng-container>
      </query-builder>
    </div>
  </div>
  <div class="row sticky dialog-footer-container" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
    <div class="col-12 unset-p">
      <div class="flex justify-right padding10 dialog-footer">
        <button class="btn font17" (click)="save()">
          <fa-icon [icon]="faFloppyDisk" class="textGreen"></fa-icon>
          <span [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
            {{app.translations.GBL_btn_SaveText}}
          </span>
        </button>
      </div>
    </div>
  </div>
</p-dialog>